import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import "./auth";
import { syncUserIdFromQuery } from "./session";
import { applyPresenceTheme, readPresenceAccent, readPresenceTheme } from "./shell/theme";
import "./index.css";

syncUserIdFromQuery();
applyPresenceTheme(readPresenceTheme(), readPresenceAccent());

const root = document.getElementById("root");
if (root) {
  createRoot(root).render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
}
